<app-panel-expandable text="Annotations" [fixed]="fixed" [expanded]="annotationsExpanded" width="35rem"
                      [body]="annotationsTmpl" [description]="annotationsPopoverBody"></app-panel-expandable>
<ng-template #annotationsTmpl>
    <app-container [body]="annotationsContainer" [isEnabled]="isAnnotationsEnabled" overlayTooltip="You do not have permission to edit the properties in this subresource"></app-container>

    <ng-template #annotationsContainer>
        <div class="label-container">
            <app-add-labels [labels]="annotations" [definition]="KeyValueDefinitions.AnnotationsDefinition"
                            [isEnabled]="isAnnotationsEnabled"
		                    #addAnnotationsComponent></app-add-labels>
        </div>
    </ng-template>

</ng-template>
<ng-template #annotationsPopoverBody>
    Annotations are string key/value pairs that you can attach as arbitrary non-identifying metadata to your objects,
    which can be leveraged by tools and libraries.
    <br><br>
    Annotations are not indexed, which means they cannot be used to identify or select objects. If you want to apply
    identifying information, use labels instead.
    <br><br>
    An <b>annotation key</b> can have two segments: an optional prefix, and a name separated by a slash (/).
    <ul>
        <li>
            The prefix of the key is optional. If a prefix is specified, the prefix must be a lowercase DNS subdomain (a
            series of DNS labels must be separated by dots) with a maximum of 253 characters in total.
        </li>
        <li>
            The name segment of the key is required. It can have a maximum 63 characters, must begin and end with a
            lowercase alphanumeric character ([a-z0-9]), and can contain dashes (-) and lowercase alphanumerics in
            between.
        </li>
    </ul>
    An <b>annotation value</b> can be any string.
</ng-template>

<div style="margin-top: 1rem; margin-bottom: 1rem">
    <app-panel-expandable text="Labels" [fixed]="fixed" [expanded]=labelsExpanded width="35rem" [body]="labelsTmpl"
                          [description]="labelsPopoverBody"></app-panel-expandable>
    <ng-template #labelsTmpl>
        <app-container [body]="labelsContainer" [isEnabled]="isLabelsEnabled" overlayTooltip="You do not have permission to edit the properties in this subresource"></app-container>
        <ng-template #labelsContainer>
            <div class="label-container">
                <app-add-labels [labels]="labels" [definition]="KeyValueDefinitions.LabelsDefinition"
                                [isEnabled]="isLabelsEnabled"
		                        #addLabelsComponent></app-add-labels>
            </div>
        </ng-template>
    </ng-template>
    <ng-template #labelsPopoverBody>
        Labels are string key/value pairs that you can attach as grouping metadata to your resources.
        <br><br>
        Labels are indexed, which means you can use them to select or identify resources, and to search for objects that
        satisfy certain conditions or criteria. If you want to apply non-identifying information, use annotations
        instead.
        <br><br>
        A <b>label key</b> can have two segments: an optional prefix, and a name separated by a slash (/).
        <ul>
            <li>
                The prefix of the key is optional. If specified, the prefix must be a lowercase DNS subdomain (a series
                of DNS labels must be separated by dots) with a maximum of 253 characters in total.
            </li>
            <li>
                The name segment of the key is required. It can have a maximum 63 characters, must begin and end with a
                lowercase alphanumeric character ([a-z0-9]), and can contain dashes (-) and alphanumerics in between.
            </li>
        </ul>

        A <b>label value</b> can have a maximum of 253 characters or can be empty. If it has a value, it must begin and
        end with an alphanumeric character ([a-z0-9A-Z]), and can contain dashes (-), underscores (_), dots (.), and
        lowercase alphanumerics in between.
    </ng-template>
</div>
